var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('section',[_c('span',[_vm._v("Ooops...")]),_c('p',{staticClass:"desc"},[_vm._v(" Esta rota não está disponível para dispositivos móveis. ")]),_c('div',[_c('BaseButton',{attrs:{"variant":"primary"},on:{"click":_vm.backHome}},[_vm._v("Voltar à página principal")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }